import { render, staticRenderFns } from "./GeneralButton.vue?vue&type=template&id=71db0ffe"
import script from "./GeneralButton.ts?vue&type=script&lang=ts&external"
export * from "./GeneralButton.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports